var _g, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_20993)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#EAF0F8"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_18_20993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7774 32.6494L24.873 35.5673H16.6791V35.5491L16.6611 35.5673H16.6791V47.1822H10.875V29.7314H24.873L27.7774 32.6494Z",
    fill: "url(#paint0_linear_18_20993)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0761 32.649L28.4814 44.2979H20.2536L31.8709 32.649L26.0781 26.829H13.8019L8 21H28.4814L40.0761 32.649Z",
    fill: "url(#paint1_linear_18_20993)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M20.2539 44.2984L40.0764 32.6494H31.8712L20.2539 44.2984Z",
    fill: "black"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.8571,
    cy: 3.85714,
    r: 3.85714,
    fill: "#4CB944"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_20993",
    x1: 5.81783,
    y1: 31.6881,
    x2: 48,
    y2: 55.1515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#552CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05D4FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_20993",
    x1: 9.82338,
    y1: 24.4847,
    x2: 52.0078,
    y2: 47.9459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#552CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05D4FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_20993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_18_20993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 26.1818,
    fill: "white",
    transform: "translate(8 21)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.acfb0990ca73a723e4036a300cb3b4c3.svg";
export { ForwardRef as ReactComponent };